import {format} from "date-fns";

export const formatToAPI = (date: Date): string => {
    return format(date, "yyyy-MM-dd'T'HH:mm:ss");
}